import { render } from "./StartScreen.vue?vue&type=template&id=e4aca658&ts=true"
import script from "./StartScreen.vue?vue&type=script&lang=ts"
export * from "./StartScreen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__